import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["anchorAttachment", "anchorOffset", "children", "constraint", "targetAttachment", "targetOffset", "withinElement"];
import { getOwnerDocument, isBrowser } from '@flowio/browser-helpers';
import eventEmitter from 'event-emitter';
import throttle from 'lodash/throttle';
import React from 'react';
import calculatePosition from '../utilities/calculatePosition';
import findDOMElement from '../utilities/findDOMElement';
import TetherContext from './TetherContext';
var initialState = {
  anchorElement: null,
  targetElement: null
};
var defaultProps = {
  anchorAttachment: 'left bottom',
  anchorOffset: '0px 0px',
  constraint: 'flip flip',
  targetAttachment: 'left top',
  targetOffset: '0px 0px',
  withinElement: 'window'
};

var Tether = /*#__PURE__*/function (_React$Component) {
  _inherits(Tether, _React$Component);

  var _super = _createSuper(Tether);

  function Tether(props) {
    var _this;

    _classCallCheck(this, Tether);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "emitter", void 0);

    _defineProperty(_assertThisInitialized(_this), "updatePositionThrottled", void 0);

    _this.state = initialState;
    _this.emitter = eventEmitter();
    _this.listenToPositionUpdates = _this.listenToPositionUpdates.bind(_assertThisInitialized(_this));
    _this.registerAnchor = _this.registerAnchor.bind(_assertThisInitialized(_this));
    _this.registerTarget = _this.registerTarget.bind(_assertThisInitialized(_this));
    _this.stopListeningToPositionUpdates = _this.stopListeningToPositionUpdates.bind(_assertThisInitialized(_this));
    _this.unregisterAnchor = _this.unregisterAnchor.bind(_assertThisInitialized(_this));
    _this.unregisterTarget = _this.unregisterTarget.bind(_assertThisInitialized(_this));
    _this.updatePositionThrottled = throttle(_this.updatePosition.bind(_assertThisInitialized(_this)), 16);
    return _this;
  }

  _createClass(Tether, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updatePosition();
      window.addEventListener('touchmove', this.updatePositionThrottled);
      window.addEventListener('resize', this.updatePositionThrottled);
      window.addEventListener('scroll', this.updatePositionThrottled);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updatePosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('touchmove', this.updatePositionThrottled);
      window.removeEventListener('resize', this.updatePositionThrottled);
      window.removeEventListener('scroll', this.updatePositionThrottled);
    }
  }, {
    key: "getWithinElement",
    value: function getWithinElement() {
      var withinElement = this.props.withinElement;

      if (!isBrowser || withinElement == null) {
        return null;
      }

      if (withinElement === 'window') {
        return window;
      }

      if (withinElement === 'document') {
        return getOwnerDocument(findDOMElement(this));
      }

      return findDOMElement(withinElement);
    }
  }, {
    key: "listenToPositionUpdates",
    value: function listenToPositionUpdates(subscriber) {
      this.emitter.on('updatePosition', subscriber);
    }
  }, {
    key: "registerAnchor",
    value: function registerAnchor(instance) {
      this.setState({
        anchorElement: findDOMElement(instance)
      });
    }
  }, {
    key: "registerTarget",
    value: function registerTarget(instance) {
      this.setState({
        targetElement: findDOMElement(instance)
      });
    }
  }, {
    key: "stopListeningToPositionUpdates",
    value: function stopListeningToPositionUpdates(subscriber) {
      this.emitter.off('updatePosition', subscriber);
    }
  }, {
    key: "unregisterAnchor",
    value: function unregisterAnchor() {
      this.setState({
        anchorElement: null
      });
    }
  }, {
    key: "unregisterTarget",
    value: function unregisterTarget() {
      this.setState({
        targetElement: null
      });
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this$props = this.props,
          anchorOffset = _this$props.anchorOffset,
          anchorAttachment = _this$props.anchorAttachment,
          constraint = _this$props.constraint,
          targetOffset = _this$props.targetOffset,
          targetAttachment = _this$props.targetAttachment;
      var _this$state = this.state,
          anchorElement = _this$state.anchorElement,
          targetElement = _this$state.targetElement;

      if (anchorElement == null || targetElement == null) {
        return;
      }

      var withinElement = this.getWithinElement();

      if (withinElement == null) {
        return;
      }

      var _calculatePosition = calculatePosition({
        anchorAttachment: anchorAttachment,
        anchorElement: anchorElement,
        anchorOffset: anchorOffset,
        constraint: constraint,
        targetAttachment: targetAttachment,
        targetElement: targetElement,
        targetOffset: targetOffset,
        withinElement: withinElement
      }),
          position = _calculatePosition.position,
          feedback = _calculatePosition.feedback;

      this.emitter.emit('updatePosition', {
        position: position,
        feedback: feedback
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchorAttachment = _this$props2.anchorAttachment,
          anchorOffset = _this$props2.anchorOffset,
          children = _this$props2.children,
          constraint = _this$props2.constraint,
          targetAttachment = _this$props2.targetAttachment,
          targetOffset = _this$props2.targetOffset,
          withinElement = _this$props2.withinElement,
          unhandledProps = _objectWithoutProperties(_this$props2, _excluded);

      var context = {
        /* eslint-disable @typescript-eslint/unbound-method */
        listenToPositionUpdates: this.listenToPositionUpdates,
        registerAnchor: this.registerAnchor,
        registerTarget: this.registerTarget,
        stopListeningToPositionUpdates: this.stopListeningToPositionUpdates,
        unregisterAnchor: this.unregisterAnchor,
        unregisterTarget: this.unregisterTarget
        /* eslint-enable @typescript-eslint/unbound-method */

      };
      return /*#__PURE__*/React.createElement("span", unhandledProps, /*#__PURE__*/React.createElement(TetherContext.Provider, {
        value: context
      }, children));
    }
  }]);

  return Tether;
}(React.Component);

_defineProperty(Tether, "displayName", 'Tether');

_defineProperty(Tether, "defaultProps", defaultProps);

export default Tether;